require.register("work/app", function(exports, require, module){
  $0
  
});

